/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1RetailerchannelsQueryResponse } from '../../types/GetV1Retailerchannels.ts'

export const getV1RetailerchannelsQueryKey = () => [{ url: '/v1/RetailerChannels' }] as const

export type GetV1RetailerchannelsQueryKey = ReturnType<typeof getV1RetailerchannelsQueryKey>

/**
 * {@link /v1/RetailerChannels}
 */
export async function getV1Retailerchannels(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1RetailerchannelsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/RetailerChannels`, ...requestConfig })
    return res
}

export function getV1RetailerchannelsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1RetailerchannelsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1RetailerchannelsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1RetailerchannelsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Retailerchannels(config)
        },
    })
}

/**
 * {@link /v1/RetailerChannels}
 */
export function useGetV1Retailerchannels<
    TData = ResponseConfig<GetV1RetailerchannelsQueryResponse>,
    TQueryData = ResponseConfig<GetV1RetailerchannelsQueryResponse>,
    TQueryKey extends QueryKey = GetV1RetailerchannelsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1RetailerchannelsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1RetailerchannelsQueryKey()

    const query = useQuery(
        {
            ...getV1RetailerchannelsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
